import { render, staticRenderFns } from "./sister-QuestionUs.vue?vue&type=template&id=f6673c0c&scoped=true&"
import script from "./sister-QuestionUs.vue?vue&type=script&lang=ts&"
export * from "./sister-QuestionUs.vue?vue&type=script&lang=ts&"
import style0 from "./sister-QuestionUs.vue?vue&type=style&index=0&id=f6673c0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6673c0c",
  null
  
)

export default component.exports